import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { t } from 'ttag';
import Slide, { ISlide } from '../../../../core/Slide';
import Content from '../../../../general/Content';
import MultipleChoice, { TMultiChoiceQuestion } from '../../../../interactive/quiz/multi-choice/MultiChoice';

const AttributesQuiz: React.FC<ISlide> = ({ defaultHeader, nextSlide, gotoSlide, currentIndex }) => {
    const gameData: TMultiChoiceQuestion[] = [
        {
            question: t`What is an attribute?`,
            answers: [
                { text: t`It is the difference in size between two objects.`, correct: false },
                { text: t`It shows how many objects there are.`, correct: false },
                { text: t`It is a feature of something.`, correct: true },
            ],
        },
    ];

    return (
        <Slide header={defaultHeader}>
            <Row>
                <Col xs={'12'} className={'text-center'}>
                    <Content type={'island'} styles={'p-3'}>
                        <MultipleChoice
                            gameData={gameData}
                            onGameComplete={nextSlide}
                            onIncorrectAnswer={() => gotoSlide(currentIndex - 2)}
                        ></MultipleChoice>
                    </Content>
                </Col>
            </Row>
        </Slide>
    );
};

export default AttributesQuiz;
